import { translate } from "@utils";

import { PolicyLevelsChipList } from "@modules/cve/components";

import Chip from "@mui/material/Chip";

const centerAlign = {
	muiTableHeadCellProps: {
		align: "center",
	},
	muiTableBodyCellProps: {
		align: "center",
	},
};

export const defaultColumnVisability = { published: false, vendors: false, products: false, cveIds: false };

export const PoliciesTableColumns = () => [
	{
		header: translate("policyId"),
		accessorKey: "policyId",
		//Cell: ({ renderedCellValue }) => renderedCellValue,
		Cell: ({ renderedCellValue }) => {
			return (!renderedCellValue) ? 'pending save...' : renderedCellValue;
		},
		size: 100,
		...centerAlign,
	},
	{
		header: translate("name"),
		accessorKey: "name",
		sortingFn: "alphanumeric",
		Cell: ({ renderedCellValue }) => renderedCellValue,
		...centerAlign,
	},
	{
		header: translate("published"),
		accessorKey: "published",
		size: 100,
		accessorFn: (row) => new Date(row.createdAt).toDateString().slice(4),
		Cell: ({ renderedCellValue }) => new Date(renderedCellValue).toDateString().slice(4),
		...centerAlign,
	},
	{
		header: `${translate("action")}`,
		accessorKey: "action",
		size: 100,
		accessorFn: (row) => ["BLOCK", "ALLOW", "ALERT"][Number(row.action) - 1],
		Cell: ({ renderedCellValue }) => renderedCellValue,
		...centerAlign,
	},
	{
		header: translate("hasExploit"),
		accessorKey: "hasExploit",
		size: 100,
		accessorFn: (row) => row.hasExploit,
		Cell: ({ renderedCellValue }) => (renderedCellValue ? "TRUE" : renderedCellValue === null ? "N/A" : "FALSE"),
		...centerAlign,
	},
	{
		header: translate("hasPatch"),
		accessorKey: "hasPatch",
		size: 100,
		accessorFn: (row) => row.hasPatch,
		Cell: ({ renderedCellValue }) => (renderedCellValue ? "TRUE" : renderedCellValue === null ? "N/A" : "FALSE"),
		...centerAlign,
	},
	{
		header: translate("severities"),
		accessorKey: "severities",
		Cell: ({ row }) => {
			return (
				<div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
					{row.original.severities.map((severity) => {
						let colorMap = { critical: "error", high: "warning", medium: "success", low: "info" };
						return <Chip key={severity} label={translate(severity)} color={colorMap[severity]} />;
					})}
				</div>
			);
		},
	},
	{
		header: translate("vendors"),
		accessorKey: "vendors",
		accessorFn: (row) => row.vendors.map((v) => v).join(", "),
	},
	{
		header: translate("products"),
		accessorKey: "products",
		accessorFn: (row) => row.products.map((v) => v).join(", "),
	},
	{
		header: translate("cveIds"),
		accessorKey: "cveIds",
		accessorFn: (row) => row.cveIds.map((v) => v).join(", "),
	},
	{
		header: translate("assignments"),
		accessorKey: "assignments",
		minSize: 200,
		Cell: ({ row }) => <PolicyLevelsChipList policy={row.original} />,
	},
];
